<template>
  <el-form ref="baseForm" v-loading="loading" v-bind="$attrs" :model="model" :label-suffix="labelSuffix">
    <!-- 如果传递 是否需要自定义标签 -->
    <template v-for="(item, index) in formItems.filter((item) => item.show !== false)">
      <!-- 分割线title -->
      <div v-if="item.renderType === 'lineTitle'" :key="getKey(item, index)" style="font-weight: bold; font-size: 20px; color: #000; margin-bottom: 20px" v-bind="$attrs">
        {{ item.label }}
      </div>
      <!-- 按钮 -->
      <el-button v-else-if="item.renderType === 'search'" :key="item.label || item._id"  v-bind="item" v-on="item" @click.stop="onSearch">
        {{ item.label || '搜索' }}
      </el-button>
      <el-button v-else-if="item.renderType === 'reset'" :key="item.label || item._id"  v-bind="item" v-on="item" @click.stop="onReset">
        {{ item.label || '重置' }}
      </el-button>
      <el-button v-else-if="item.renderType === 'collaps'" :key="item.label || item._id" type="primary" plain  v-bind="item" v-on="item" @click.stop="onCollaps">
        <!-- 这个不支持自定义label -->
        <span>{{ collapsed ? '收起更多筛选' : '展开更多筛选' }}</span>
        <i :class="{'el-icon-arrow-down': !collapsed, 'el-icon-arrow-up': collapsed }" />
      </el-button>
      
      <el-button v-else-if="item.renderType === 'button'" :key="item.label || item._id" v-permission="item.permission"  v-bind="item" v-on="item">
        {{ item.label }}
      </el-button>
      <!-- 当前有自定义情况 -->
      <RenderDom v-else-if="item.render" :key="item._key || item.label || item._id" :render="item.render" :props="$attrs" />

      <el-form-item v-else v-bind="item" :key="item._key || item.label || item._id" :label="item.label" :prop="getProp(item)">
        <!-- 如果有tooltip 那么就需要自定义label -->
        <template v-if="item.tooltip">
          <div slot="label">
            <el-popover placement="top-start" trigger="hover">
              <div v-html="item.tooltip" />
              <div slot="reference">
                {{ item.label }}<i class="el-icon-question" style="color: #606266; margin-left: 8px" />
              </div>
            </el-popover>
          </div>
        </template>

        <!-- 自定义label -->
        <template v-if="item.renderLabel">
          <div slot="label">
            <RenderDom :key="item._key || item.label || item._id" :render="item.renderLabel" :props="$attrs" />
          </div>
        </template>

        <!-- 不支持requre 自动生成校验 -->
        <!-- child 为数组的时候 也就是多个的时候 -->
        <template v-if="Array.isArray(item.child)">
          <BaseFormRender v-for="(child,childIndex) in item.child.filter(obj=>obj.show !== false)" v-bind="child" :key="childIndex" style="display: inline-block;margin-right:8px;" :renderData="item" v-on="child" />
        </template>
        <template v-else>
          <BaseFormRender v-bind="item.child" :renderData="item" v-on="item.child" />
        </template>
        <div v-html="item.member" />
      </el-form-item>
    </template>
  </el-form>
</template>
<script>
/**
 * @desc 基础组件  form表单组件
 */
import BaseFormRender from './BaseFormRender'
import RenderDom from '@/utils/renderDom'
import { cloneDeep } from 'lodash'
export default {
  name: 'BaseForm',
  components: {
    BaseFormRender,
    RenderDom
  },
  provide () {
    return {
      baseForm: this
    }
  },
  inheritAttrs: false,
  props: {
    /**
     * @desc formItem 循环
     */
    model: {
      type: Object,
      default: () => {}
    },
    formItems: {
      type: Array,
      required: true,
      default: () => [],
      validate: (value) => {
        return Array.isArray(value)
      }
    },
    labelSuffix: {
      type: String,
      default: '：'
    },
    loading: {
      type: Boolean,
      default: false
    },
    // 是否展开
    collapsed:{
      type:Boolean,
      default: false
    }
  },
  data () {
    return {
      defaultModel: null
    }
  },
  created () {
    if (this.model) {
      this.$nextTick((obj) => {
        // 收集重置数据
        this.defaultModel = cloneDeep(this.model)
      
      })
    }
  },
  
  methods: {
    /** 添加筛选模板 */
    onAddSearchTemplate(){
      this.$emit('addSearchTemplate')
    },
    /** 展开和收起 */
    onCollaps(){
      this.$emit('update:collapsed', !this.collapsed)
    },
    /** 得道el-form-prop */
    getProp (item) {
      return this.$attrs.rules || item.rules ? item.prop || item.child.valueKey : undefined
    },
    getKey (item, index) {
      return item._key || item._id || item.label || index
    },
    // form 搜索button
    onSearch () {
      this.$emit('search', this.model)
    },
    // form 搜索button
    onReset () {
      this.$emit('reset')
    },
    /**
     * @description 校验form表单字段
     */
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.baseForm.validate((valid) => {
          resolve(valid)
        })
      })
    },
    // 重置model
    resetModel () {
      this.$emit('update:model', cloneDeep(this.defaultModel))
      const baseForm = this.$refs.baseForm
      this.$nextTick(() => {
        baseForm.resetField && baseForm.resetField()
        baseForm.clearValidate && baseForm.clearValidate()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.form-item-content {
  .form-item-content-member {
    margin-left: 12px;
    display: inline-block;
  }
  .form-item-content-render {
    display: inline-block;
  }
}
</style>
